import { render, staticRenderFns } from "./PaymentApproveButton.vue?vue&type=template&id=39a77b83"
import script from "./PaymentApproveButton.vue?vue&type=script&lang=ts"
export * from "./PaymentApproveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports